const normalizedToken = value =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase();

export const normalizeLanguageCode = value => {
  const token = normalizedToken(value).replace('_', '-');
  if (['pt', 'pt-br'].includes(token) || token.includes('portugu')) {
    return 'pt-BR';
  }
  if (token === 'en' || token.includes('english') || token.includes('ingles')) {
    return 'en';
  }
  if (
    token === 'es' ||
    token.includes('spanish') ||
    token.includes('espanhol') ||
    token.includes('espanol')
  ) {
    return 'es';
  }
  return 'pt-BR';
};

export const normalizeResponseLengthCode = value => {
  const token = normalizedToken(value);
  if (token === 'short' || token.includes('curt') || token.includes('breve')) {
    return 'short';
  }
  if (token === 'medium' || token.includes('medi')) return 'medium';
  if (
    token === 'complete' ||
    token.includes('complet') ||
    token.includes('detalhad')
  ) {
    return 'complete';
  }
  return 'short';
};
